module.exports = __webpack_public_path__ + "static/media/key-card.28d2f320.svg";